var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4198 1.71136C-0.0923595 3.60784 -0.303003 6.62855 3.27931 8.66552C6.93196 10.843 13.0431 10.843 16.7658 8.66552C19.9267 6.90951 20.278 4.09991 17.1169 2.06256C13.4643 -0.255404 7.2127 -0.325721 3.41973 1.71142L3.4198 1.71136Z",
    fill: "#5D688B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.679688 14.2148V16.7436C0.679688 18.3591 2.22505 19.6235 3.62989 20.3259C7.28253 22.2224 12.8317 22.2224 16.414 20.3259C17.8189 19.6235 19.2939 18.3591 19.2939 16.7436V14.2148C18.6617 14.9173 17.8188 15.4792 16.9056 15.9007C12.9721 17.9376 7.07158 17.9376 3.13813 15.9709C2.22505 15.4792 1.38213 14.9173 0.679688 14.2148V14.2148Z",
    fill: "#5D688B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2937 8.45312C18.8021 9.01508 18.1698 9.50669 17.3972 9.92817C13.3233 12.2461 6.72034 12.2461 2.57617 9.92817C1.80357 9.50673 1.17129 9.01508 0.679688 8.45312V10.9819C0.679688 12.6677 2.29521 13.9321 3.70005 14.6345C7.28238 16.4608 12.7614 16.4608 16.3437 14.6345C17.7485 13.9321 19.2939 12.6677 19.2939 10.9819L19.2937 8.45312Z",
    fill: "#5D688B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSources);
export default __webpack_public_path__ + "static/media/nav-sources.09afa6f0.svg";
export { ForwardRef as ReactComponent };